import {
    MgmConfig,
    MgmKickbackConfig,
    MgmMinimumAmountConfig,
} from "refsix-js-models";

export const MGM_FALLBACK_KICKBACK_AMOUNT = 10;

export function pickMgmKickbackConfig(
    config: MgmConfig,
    country: string,
    currency: string
): MgmKickbackConfig | undefined {
    let kickback = config.kickbacks.find(
        (k) =>
            k.country?.toLowerCase() === country?.toLowerCase() &&
            k.currency.toLowerCase() === currency.toLowerCase()
    );
    if (!kickback) {
        kickback = config.kickbacks.find(
            (k) => k.currency.toLowerCase() === currency.toLowerCase()
        );
    }

    return kickback;
}

export function pickMgmMinimumAmount(
    config: MgmConfig,
    currency: string
): MgmMinimumAmountConfig | undefined {
    return config.minimumAmount?.find(
        (m) => m.currency.toLowerCase() === currency.toLowerCase()
    );
}

/**
 *
 * @param amountPaid From the stripe invoice amount_paid
 * @param startingBalance From the stripe invoice starting_balance but flipped to positive number e.g. 300 for £3.00
 */
export function calculateCreditUsed(
    amountPaid: number,
    startingBalance: number
) {
    if (startingBalance) {
        return Math.max(Math.min(startingBalance, amountPaid), 0);
    }
    return;
}
